import { createContext } from "react";
import type { SuperuserContextValue } from "./superuser.types";

export const SuperuserContext = createContext<SuperuserContextValue>({
  isSuperuserMode: false,
  setIsSuperuserMode: () => {},
  impersonatedUser: null,
  startImpersonation: async () => {},
  stopImpersonation: async () => {},
  impersonatedRole: null,
  startRoleImpersonation: async () => {},
  stopRoleImpersonation: async () => {},
});
